 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-en-js":"lang-en-js","lang-es-js":"lang-es-js","lang-lt-js":"lang-lt-js","lang-no-js":"lang-no-js","lang-sv-js":"lang-sv-js"}[chunkId]||chunkId) + "." + {"chunk-0227d04a":"d4bbbd11","chunk-1e1825fe":"b47ee839","chunk-1fd53b08":"7d04ff22","chunk-2d0b2ed7":"3b79401d","chunk-fbd596f6":"fc6e7d76","chunk-357c64f5":"f4d9ab3c","chunk-2d0b37a5":"1fdf07e2","chunk-2d210f7e":"acf3f20c","chunk-4a5f46a6":"f127ac0b","chunk-52ce9db9":"3c9b0311","chunk-5a6a5d3b":"8373937f","chunk-5ea4eee8":"d7dbf14e","chunk-4315f054":"ea827e78","chunk-cc7799e0":"ffdabec7","chunk-0204ea16":"5e8cad75","chunk-06a45a58":"84f29c13","chunk-c29475f2":"ad078d85","chunk-4ec34ca9":"66da304e","chunk-930004a2":"43942d60","chunk-df280af4":"e524c51f","chunk-510d4593":"9f710ffe","chunk-3d7395fc":"5a0492df","chunk-46d7da16":"eaa7ed49","chunk-6f841ba8":"cc951013","chunk-01505322":"8b31f1e4","chunk-7ac9f0f2":"e1f9de0a","chunk-6bcf740e":"6f3510d8","chunk-8125632a":"678e85b9","chunk-557dec3e":"261137c4","chunk-71c04388":"1d9f931a","chunk-6459b170":"f89f27f6","chunk-717def2a":"e3415e21","chunk-05dde80e":"b1f9b50c","chunk-0e8f1b1e":"eea49077","chunk-e08a3e42":"42f5d56e","chunk-8aea682c":"c39eaf3b","chunk-027d669b":"730c47ca","chunk-1285e9ac":"23c6368c","chunk-13d6257a":"93864e80","chunk-145e1aac":"949c8168","chunk-170216e2":"cbb4192f","chunk-17037daa":"586be625","chunk-1dbe6cb5":"e096fa01","chunk-1e3d36af":"1b2b49b2","chunk-22eba2e6":"61245f15","chunk-2d224e86":"4b3bc236","chunk-604192e0":"4b48a6cf","chunk-2d0b381b":"01aa97cc","chunk-3060475c":"5e4c0cd0","chunk-318a53de":"ac8363a0","chunk-025d1923":"5d021184","chunk-02f5c234":"72d68c28","chunk-329fa766":"986db2a6","chunk-4483a3be":"e217972c","chunk-48224f23":"7c9c6814","chunk-08a89107":"50993654","chunk-2c1b7549":"24d7c2da","chunk-3368d531":"b874ebe0","chunk-47bfa970":"12ac9576","chunk-ad68273a":"636fe753","chunk-05f89b60":"429c11a1","chunk-4ceebdcb":"d961a101","chunk-5ea6cb7e":"ab673f9a","chunk-4e306504":"47f8d979","chunk-2d0e5b75":"a94690aa","chunk-4fbdcd8a":"293575de","chunk-7f673cba":"c8509aba","chunk-05e6db76":"b79d3612","chunk-bb8db7cc":"f6f5dd1b","chunk-2e8fde22":"4256ae49","chunk-31a5063c":"e11638ca","chunk-322c87b8":"70360c1d","chunk-371140a8":"a63522d5","chunk-90c06388":"7419f73a","chunk-bb8e7fd8":"a24afd34","chunk-52730370":"a87bd4b9","chunk-58bc4e52":"57907d75","chunk-5bded8a3":"a1ea49de","chunk-6366ceaf":"9f8d1ad5","chunk-1db92b05":"b8286f92","chunk-2d0c8dd8":"240bd262","chunk-6efa8fb8":"52330c65","chunk-8bed7cc0":"7edca502","chunk-985d7754":"fc9e1a27","chunk-c4353338":"8f5e1e3b","lang-en-js":"4118e009","lang-es-js":"396ae269","lang-lt-js":"b4a4f9b2","lang-no-js":"ece6c681","lang-sv-js":"43d28c3c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0227d04a":1,"chunk-1e1825fe":1,"chunk-1fd53b08":1,"chunk-357c64f5":1,"chunk-52ce9db9":1,"chunk-5a6a5d3b":1,"chunk-5ea4eee8":1,"chunk-4315f054":1,"chunk-cc7799e0":1,"chunk-0204ea16":1,"chunk-06a45a58":1,"chunk-c29475f2":1,"chunk-930004a2":1,"chunk-df280af4":1,"chunk-510d4593":1,"chunk-3d7395fc":1,"chunk-46d7da16":1,"chunk-6f841ba8":1,"chunk-01505322":1,"chunk-7ac9f0f2":1,"chunk-6bcf740e":1,"chunk-8125632a":1,"chunk-557dec3e":1,"chunk-71c04388":1,"chunk-6459b170":1,"chunk-717def2a":1,"chunk-05dde80e":1,"chunk-0e8f1b1e":1,"chunk-e08a3e42":1,"chunk-8aea682c":1,"chunk-027d669b":1,"chunk-1285e9ac":1,"chunk-145e1aac":1,"chunk-1dbe6cb5":1,"chunk-1e3d36af":1,"chunk-22eba2e6":1,"chunk-604192e0":1,"chunk-3060475c":1,"chunk-318a53de":1,"chunk-025d1923":1,"chunk-02f5c234":1,"chunk-329fa766":1,"chunk-4483a3be":1,"chunk-48224f23":1,"chunk-2c1b7549":1,"chunk-3368d531":1,"chunk-47bfa970":1,"chunk-ad68273a":1,"chunk-05f89b60":1,"chunk-4ceebdcb":1,"chunk-5ea6cb7e":1,"chunk-4e306504":1,"chunk-4fbdcd8a":1,"chunk-7f673cba":1,"chunk-05e6db76":1,"chunk-2e8fde22":1,"chunk-31a5063c":1,"chunk-322c87b8":1,"chunk-371140a8":1,"chunk-90c06388":1,"chunk-52730370":1,"chunk-58bc4e52":1,"chunk-5bded8a3":1,"chunk-6366ceaf":1,"chunk-1db92b05":1,"chunk-6efa8fb8":1,"chunk-8bed7cc0":1,"chunk-985d7754":1,"chunk-c4353338":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-en-js":"lang-en-js","lang-es-js":"lang-es-js","lang-lt-js":"lang-lt-js","lang-no-js":"lang-no-js","lang-sv-js":"lang-sv-js"}[chunkId]||chunkId) + "." + {"chunk-0227d04a":"ea25f702","chunk-1e1825fe":"2682f556","chunk-1fd53b08":"e9a430f6","chunk-2d0b2ed7":"31d6cfe0","chunk-fbd596f6":"31d6cfe0","chunk-357c64f5":"a4e5e3fb","chunk-2d0b37a5":"31d6cfe0","chunk-2d210f7e":"31d6cfe0","chunk-4a5f46a6":"31d6cfe0","chunk-52ce9db9":"aa68df6e","chunk-5a6a5d3b":"ad42f181","chunk-5ea4eee8":"28c2be7b","chunk-4315f054":"78ed1876","chunk-cc7799e0":"01f31a57","chunk-0204ea16":"73f39597","chunk-06a45a58":"d0b91d96","chunk-c29475f2":"79fd7741","chunk-4ec34ca9":"31d6cfe0","chunk-930004a2":"946c3616","chunk-df280af4":"cf9b24b8","chunk-510d4593":"05e35b4e","chunk-3d7395fc":"0ec17f99","chunk-46d7da16":"8fe6b5b5","chunk-6f841ba8":"25cf4403","chunk-01505322":"c43890dc","chunk-7ac9f0f2":"5e9a8bc4","chunk-6bcf740e":"4648851a","chunk-8125632a":"ebbe3e5e","chunk-557dec3e":"81d419bf","chunk-71c04388":"b512ca08","chunk-6459b170":"bb984d02","chunk-717def2a":"28d7241d","chunk-05dde80e":"8c36e402","chunk-0e8f1b1e":"408f5845","chunk-e08a3e42":"fe5bc855","chunk-8aea682c":"0a4b198d","chunk-027d669b":"36185a3a","chunk-1285e9ac":"b5051eff","chunk-13d6257a":"31d6cfe0","chunk-145e1aac":"9196ef73","chunk-170216e2":"31d6cfe0","chunk-17037daa":"31d6cfe0","chunk-1dbe6cb5":"ebec4b33","chunk-1e3d36af":"42a762a7","chunk-22eba2e6":"0ebe72a5","chunk-2d224e86":"31d6cfe0","chunk-604192e0":"fe669427","chunk-2d0b381b":"31d6cfe0","chunk-3060475c":"aaf74944","chunk-318a53de":"dbadae5b","chunk-025d1923":"aad287a8","chunk-02f5c234":"55b8e50d","chunk-329fa766":"36bced2a","chunk-4483a3be":"aac88883","chunk-48224f23":"7a00eac9","chunk-08a89107":"31d6cfe0","chunk-2c1b7549":"0b9c53be","chunk-3368d531":"e07c834d","chunk-47bfa970":"9196ef73","chunk-ad68273a":"b2bc1b03","chunk-05f89b60":"f70f5043","chunk-4ceebdcb":"506b9909","chunk-5ea6cb7e":"f70f5043","chunk-4e306504":"75dbfa07","chunk-2d0e5b75":"31d6cfe0","chunk-4fbdcd8a":"16533eba","chunk-7f673cba":"78ed1876","chunk-05e6db76":"9196ef73","chunk-bb8db7cc":"31d6cfe0","chunk-2e8fde22":"b09f3049","chunk-31a5063c":"9196ef73","chunk-322c87b8":"9196ef73","chunk-371140a8":"9196ef73","chunk-90c06388":"ffe15830","chunk-bb8e7fd8":"31d6cfe0","chunk-52730370":"3d8b0be1","chunk-58bc4e52":"471fb1cb","chunk-5bded8a3":"5dc80713","chunk-6366ceaf":"84484820","chunk-1db92b05":"f2e62319","chunk-2d0c8dd8":"31d6cfe0","chunk-6efa8fb8":"c201d3fe","chunk-8bed7cc0":"4ec8383a","chunk-985d7754":"3d8b0be1","chunk-c4353338":"78ed1876","lang-en-js":"31d6cfe0","lang-es-js":"31d6cfe0","lang-lt-js":"31d6cfe0","lang-no-js":"31d6cfe0","lang-sv-js":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
